<template>
  <DialogHeader v-if="useMobileLayout">
    <template #right>
      <div
        class="font-medium text-green-900 cursor-pointer"
        @click="handleClick"
      >
        Agree
      </div>
    </template>
    Confirm rights
  </DialogHeader>
  <DialogContent>
    <img class="w-[52px] h-[60px] mb-4 mx-auto" :src="imageUrl" />
    <div class="font-semibold font-primary text-[17px] text-center mb-4">
      Confirmation of right to add the work to Dacr
    </div>
    <div class="text-[14px] mb-2.5">
      I, the undersigned, hereby certify that I am the author, copyright owner,
      owner of exclusive rights or an authorized agent of the work identified in
      the file(s) that I am adding to Dacr. If this is not correct, you may be
      committing fraud by proceeding.
    </div>
    <div class="text-[14px]">
      Proceed to confirm these statements are correct and your continued
      agreement of our
      <a class="text-link" href="/legal/terms" target="_blank">Terms</a> and
      <span class="inline-flex">
        <a class="text-link" href="/legal/privacy" target="_blank">
          Privacy Policy
        </a>
        .
      </span>
    </div>

    <Message v-if="isProPlan" class="mt-[17px]">
      You are on the
      <div class="inline-flex">
        <span class="text-gray-800 font-medium">
          {{ billingStore.billing?.plan.name }} Plan
        </span>
        .
      </div>
      You will be charged
      <span class="text-gray-800 font-medium"> {{ copyrightPrice }} once </span>
      for each copyright you add.
    </Message>
  </DialogContent>
  <DialogFooter class="flex-col gap-2.5 min-[390px]:flex-row">
    <UiButton class="w-full tablet-h:w-auto tablet-h:mr-2" @click="close()">
      Cancel upload
    </UiButton>
    <UiButton class="w-full tablet-h:w-auto" primary @click="handleClick">
      Agree, continue
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Message } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDevice } from '@/shared/composables/useDevice'
import { useDialog } from '@/shared/dialogs/useDialog'
import { computed, inject } from 'vue'
import { useBillingStore } from '@/features/billing/store'
import { BillingPriceType, PlanType } from '@/shared/graphql/legacy/generated'
import { formatPrice } from '@/shared/utils/money'

const imageUrl = new URL(`../../../assets/images/shield.png`, import.meta.url)
  .href

const { close, triggerEvent } = useDialog()
const { isMobile } = useDevice()
const billingStore = useBillingStore()

const isModal = inject<boolean>('dialogModal', false)
const useMobileLayout = computed(() => isMobile.value && !isModal)

const handleClick = () => {
  triggerEvent('success')
}

const isProPlan = computed(
  () => billingStore.billing?.plan.type === PlanType.Pro
)

const copyrightPrice = computed(() => {
  const filePrice = billingStore.billing?.plan.prices.find(
    (price) => price.type === BillingPriceType.File
  )

  if (!filePrice?.details.amount) return

  return formatPrice({
    amount: filePrice.details.amount / 100,
    hideDecimals: true,
  })
})
</script>
